import type { FC, ReactNode } from 'react';

import { CodeChip } from '../../../components/reusable/code-chip';
import { CardItems } from '../../../components/reusable/components';
import { splitElectoralCode } from '../../../components/reusable/helper';
import type { IWardSummary } from './utils';

interface IDdRow {
	title: string;
	value: string | number;
	copy?: boolean;
	action?: () => void;
	renderValue?: ReactNode;
}

export const WardSummary: FC<IWardSummary> = ({ wardData, rightPanel }) => {
	const metaDataArr = wardData?.data;
	if (!metaDataArr) return <></>;
	const metaData = metaDataArr;
	const parts = splitElectoralCode(metaData.wardCode);
	const data = metaData
		? [
				{
					title: 'Description',
					value: metaData.description || 'None',
					details: [],
				},
			]
		: [];

	const ddData: IDdRow[] = metaData
		? [
				{
					title: 'State Name/Code',
					value: `${metaData.state.name} (${parts.state ?? ''})`,
					renderValue: (
						<span className='f-row-7 align-items-center gap-7'>
							<span>{metaData.state.name}</span>
							{parts.state ? (
								<CodeChip
									code={parts.state}
									level='state'
									compact
								/>
							) : null}
						</span>
					),
					action: () => {
						rightPanel?.callSection({
							action: 'view',
							component: 'state-details',
							title: `${metaData.state.name} State`,
							data: {
								id: metaData.state.id,
							},
						});
					},
				},
				{
					title: 'Total No. of Constituencies',
					value: metaData.constituencyCount,
					action: () => {
						rightPanel?.callSection({
							action: 'view',
							component: 'ed-in-ward',
							title: `Constituencies for ${metaData.name} RA/Ward`,
							data: {
								id: metaData.id,
								electoralDivision: 'constituency',
							},
						});
					},
				},
				{
					title: 'LGA Name',
					value: metaData.lga.name,
				},
				{
					title: 'LGA Code',
					value: parts.lga ?? '',
					renderValue: (
						<CodeChip
							code={parts.lga}
							level='lga'
						/>
					),
				},
				{
					title: 'RA/Ward',
					value: metaData.name,
					copy: true,
				},
				{
					title: 'RA/Ward Code',
					value: parts.ward ?? '',
					renderValue: (
						<CodeChip
							code={parts.ward}
							level='ward'
							peek={false}
						/>
					),
				},

				{
					title: 'Total No. of Polling Units',
					value: metaData.pollingUnitCount,
					action: () => {
						rightPanel?.callSection({
							action: 'view',
							component: 'ed-in-ward',
							title: `Polling Units in ${metaData.name} RA/Ward`,
							data: {
								id: metaData.id,
								electoralDivision: 'pollingunit',
							},
						});
					},
				},
			]
		: [];

	return (
		<div className='f-column-33 text-left pt-3'>
			<div className='grid-wrapper-40 gap-30 text-left'>
				{ddData.map((i, index) => (
					<div key={index}>
						<CardItems
							title={i.title}
							value={i?.value?.toLocaleString() || ''}
							copy={i.copy}
							onHandleClick={i.action}
							renderValue={i.renderValue}
						/>
					</div>
				))}
			</div>
			<div className='f-column-33 text-left'>
				{data.map((i, index) => (
					<div key={index}>
						<CardItems
							title={i.title}
							value={i.value.toLocaleString()}
						/>
						{/* {i.details?.length ? (
              <details className="f-column-20">
                <summary className="text-tiny color-label mt-2">
                  <i>Click to see more info</i>
                </summary>
                <div className="grid-wrapper-30 gap-20 border-label rounded p-2 mt-2">
                  {i.details.map((detail, dindex) => (
                    <div key={dindex}>
                      <CardItems
                        title={detail.title}
                        value={detail?.value?.toLocaleString() || ''}
                        mini
                        onHandleClick={detail.action}
                      />
                    </div>
                  ))}
                </div>
              </details>
            ) : null} */}
					</div>
				))}
			</div>
		</div>
	);
};
